import tippy from "tippy.js";

initBadges();
function initBadges() {
  // const badges = document.querySelectorAll("[tooltip-highlight]");
  tippy("[data-tippy-content]", {
    arrow: true,
    theme: "brown",
    appendTo: "parent",
    onMount(instance) {
      // Get elements colour and set as the --colour on the parent element
      const color = instance.reference.dataset.color;
      if (!color) return;
      instance.reference.parentElement.style.setProperty("--background", color);
    },
  });

  // for (const badge of badges) {
  //   const tooltip = badge.querySelector("[tooltip-bubble]");
  //   if (!tooltip) return;

  //   badge.addEventListener("pointerenter", (event) => {
  //     console.log(event);

  //     // Position tooltip
  //     tooltip.style.position = "fixed";
  //     // tooltip.style.bottom = `calc(var(--y) + ${tooltip.scrollHeight}px)`;
  //     tooltip.style.left = event.clientX + "px";
  //     tooltip.style.top = event.clientY + "px";

  //     const bounding = tooltip.getBoundingClientRect().left;
  //     const x = Math.ceil(bounding + tooltip.offsetWidth);
  //     const parent = tooltip.closest("[tooltip-parent]");
  //     if (!parent) return;
  //     const parentBounds =
  //       parent.getBoundingClientRect().left + parent.offsetWidth;
  //     const extendsWindow = x > window.innerWidth;
  //     const extendsParent = parent && x > parentBounds;

  //     if (extendsWindow || extendsParent) {
  //       const offset = extendsWindow
  //         ? window.innerWidth - x - 10
  //         : parentBounds - x - 10;

  //       badge.style.setProperty("--offset", offset + "px");
  //       badge.style.setProperty("--tooltip-offset", Math.abs(offset) + "px");
  //     }
  //   });

  //   badge.addEventListener("pointerleave scroll", () => {
  //     tooltip.display = "none";
  //   });
  // }
}
